import { useState, useEffect } from "react";
import axios from "axios";
import { Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faFile } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";

import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";
import { getEventRegistrationList } from "actions/action";
import { getEvent } from "actions/action";
import { deleteRegistration } from "actions/action";
import { deleteEventRegistration } from "actions/action";
import { TablePagination } from "@mui/material";

export default function EventRegistrationsList() {
  const userId = localStorage.getItem("user_id");
  const location = useLocation();

  const { type, id } = location.state;
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortColumn, setSortColumn] = useState("firstName");
  const [sortOrder, setSortOrder] = useState("asc");
  const [viewFlag, setViewFlag] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [totalItems, setTotalItems] = useState(1);
  const [eventName, setEventName] = useState("");

  const fetchEventRegistrationList = async () => {
    try {
      const response = await getEventRegistrationList(id);

      if (!response.error) {
        const formattedUsers = response.data.registrations.map((user) => ({
          firstName: user.user_details.first_name,
          lastName: user.user_details.last_name,
          email: user.user_details.email,
          phone: user.user_details.phone,
          isEmailVerified: user.user_details.is_verified_email,
          isPhoneVerified: user.user_details.is_verified_phone,
          formData: {
            ...user.form_data,
            uploads: user.file_uploads
          },
          eventRegistrationId: user.event_registration_id,
          userId: user.user_id,
          eventId: user.event_id,
        }));
        setData(formattedUsers);
        setTotalItems(formattedUsers.length);
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const filteredData = data.filter(
    (item) =>
      item.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.lastName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedData = [...filteredData].sort((a, b) => {
    const comparison = a[sortColumn].localeCompare(b[sortColumn]);
    return sortOrder === "asc" ? comparison : -comparison;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handleSort = (column) => {
    setSortOrder((prevOrder) =>
      sortColumn === column && prevOrder === "asc" ? "desc" : "asc"
    );
    setSortColumn(column);
  };

  useEffect(() => {
    fetchEventRegistrationList();
    (async () => {
      try {
        const res = await getEvent(id);
        const name = res?.data?.data?.event_name || res?.data?.event_name || "";
        setEventName(name);
      } catch (e) { }
    })();
  }, []);
  async function deleteEvent(id) {
    try {
      const getApiResponse = await deleteEventRegistration(id);

      if (getApiResponse.status == 200) {
        setData([]);
        fetchEventRegistrationList();
      }
    } catch (error) {
      console.error("Error fetching facilities:", error);
    }
  }

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this records?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: ReactDOMServer.renderToString(
        <>
          Yes, delete it!
          <FontAwesomeIcon icon={faTrash} style={{ marginLeft: "10px" }} />
        </>
      ),
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteEvent(id);
        Swal.fire({
          title: "Deleted!",
          text: "Event record deleted successfully.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    });
  };
  const user_id = localStorage.getItem("user_id");
  return (
    <>
      <div className="relative">
        <div className="flex justify-between items-center  px-4 mt-6">
          <p className="font-semibold text-lg text-white capitalize">
            Event Name: {eventName || "-"}
          </p>
          <Tooltip title="Go Back" arrow>
            <button
              className="bg-lightBlue-500 mb-0 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              type="button"
              onClick={() => navigate(-1)}
            >
              {"<"}
            </button>
          </Tooltip>
        </div>
        <div className="px-6 mt-4 mb-6 ">
          <form className="flex flex-row flex-wrap items-center">
            <div className="relative flex w-full flex-wrap items-stretch">
              <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-900 bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
                <i className="fas fa-search"></i>
              </span>
              <Tooltip title="Search Record" arrow>
                <input
                  type="text"
                  placeholder="Search by First Name/ Last Name"
                  className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10 pr-10"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Tooltip>
              {searchTerm && (
                <button
                  type="button"
                  onClick={() => setSearchTerm("")}
                  className="absolute right-0 top-0 bottom-0 flex items-center justify-center w-10 text-blueGray-900 hover:text-blueGray-600 focus:outline-none"
                >
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>
          </form>
        </div>
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
          <div className="block w-full overflow-x-auto">
            <table className="items-center w-full bg-transparent border-collapse">
              <thead>
                <tr>
                  <th className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-50 text-blueGray-900 border-blueGray-100">
                    Sr.No
                  </th>
                  <th
                    className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-50 text-blueGray-900 border-blueGray-100"
                    onClick={() => handleSort("event_name")}
                  >
                    First Name
                  </th>
                  {/* <th className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-50 text-blueGray-900 border-blueGray-100" onClick={() => handleSort('created_by')}>
                    Created By {sortColumn === 'created_by' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                  </th> */}
                  <th
                    className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-50 text-blueGray-900 border-blueGray-100"
                    onClick={() => handleSort("start_date")}
                  >
                    Last Name
                  </th>
                  <th
                    className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-50 text-blueGray-900 border-blueGray-100"
                    onClick={() => handleSort("end_date")}
                  >
                    Email
                  </th>
                  <th
                    className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-50 text-blueGray-900 border-blueGray-100"
                    onClick={() => handleSort("description")}
                  >
                    Phone
                  </th>
                  <th className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-50 text-blueGray-900 border-blueGray-100">
                    Verified Email
                  </th>
                  <th className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-50 text-blueGray-900 border-blueGray-100">
                    Verified Phone
                  </th>
                  <th className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-center bg-blueGray-50 text-blueGray-900 border-blueGray-100">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length ? (
                  currentItems.map((item, index) => (
                    <tr key={item.index}>
                      <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
                        <span className="ml-3 font-bold text-blueGray-600">
                          {(currentPage - 1) * itemsPerPage + index + 1}
                        </span>
                      </td>
                      <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
                        <span className="ml-0 font-bold text-blueGray-600">
                          {item.firstName}
                        </span>
                      </td>
                      <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                        <span className="ml-0 font-bold text-blueGray-600">
                          {item.lastName}
                        </span>
                      </td>
                      <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                        <span className="ml-0 font-bold text-blueGray-600">
                          {item.email}
                        </span>
                      </td>
                      <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                        <span className="ml-0 font-bold text-blueGray-600">
                          {item.phone}
                        </span>
                      </td>
                      <td
                        className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 truncate"
                        title={item.description}
                      >
                        <span className="ml-0 font-bold text-blueGray-600">
                          {item.isEmailVerified ? "Yes" : "No"}
                        </span>
                      </td>
                      <td
                        className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 truncate"
                        title={item.description}
                      >
                        <span className="ml-0 font-bold text-blueGray-600">
                          {item.isPhoneVerified ? "Yes" : "No"}
                        </span>
                      </td>
                      <td
                        className="border-t-0 px-6 justify-center align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 truncate"
                        title={item.description}
                      >
                        <Tooltip title="View Registration Details" arrow>
                          <motion.button
                            whileHover={{ scale: 1.2, color: "#22C55E" }}
                            whileTap={{ scale: 0.9 }}
                            type="button"
                            onClick={() => {
                              navigate(`/admin/registrationInfo`, {
                                state: {
                                  formData: item.formData,
                                  userId: item.userId,
                                  eventId: item.eventId
                                },
                              });
                            }}
                            className="text-blue-500 focus:outline-none mx-4 hover:text-green-500"
                          >
                            <FontAwesomeIcon
                              icon={faFile}
                              className="text-xl"
                            />
                          </motion.button>
                        </Tooltip>
                        <Tooltip title="View Registration Details" arrow>
                          <motion.button
                            whileHover={{ scale: 1.2, color: "#22C55E" }}
                            whileTap={{ scale: 0.9 }}
                            type="button"
                            onClick={() =>
                              handleDelete(item.eventRegistrationId)
                            }
                            className="text-red-500 focus:outline-none mx-4 hover:text-red-500"
                          >
                            <FontAwesomeIcon
                              icon={faTrash}
                              className="text-xl"
                            />
                          </motion.button>
                        </Tooltip>
                      </td>
                      {/* <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-center flex gap-4">

                      <Tooltip title="Edit" arrow>
                        <motion.button
                          whileHover={{ scale: 1.2, color: "#2563EB" }}
                          whileTap={{ scale: 0.9 }}
                          type="button"
                          onClick={() => {
                              navigate(`/admin/editEvent`, { state: {type:"edit", id: item.id } });
                            }
                          }
                          className="text-blue-500 hover:text-blue-700 focus:outline-none">
                          <FontAwesomeIcon icon={faPenToSquare} className="text-xl" />
                        </motion.button>
                      </Tooltip>

                      <Tooltip title="Delete" arrow>
                        <motion.button
                          whileHover={{ scale: 1.2, color: "#DC2626" }}
                          whileTap={{ scale: 0.9 }}
                          type="button"
                          className="text-blue-500 hover:text-red-700 focus:outline-none mx-4"
                          onClick={() => handleDelete(item.id)}
                        >
                          <FontAwesomeIcon icon={faTrash} className="text-xl" />
                        </motion.button>
                      </Tooltip>

                      <Tooltip title="View" arrow>
                        <motion.button
                          whileHover={{ scale: 1.2, color: "#FACC15" }}
                          whileTap={{ scale: 0.9 }}
                          type="button"
                          onClick={() => navigate(`/admin/viewEvent`,{ state: { type:"view",id: item.id } })}
                          className="text-blue-500 focus:outline-none mx-3 hover:text-yellow-500">
                          <FontAwesomeIcon icon={faEye} className="text-xl" />
                        </motion.button>
                      </Tooltip>

                      <Tooltip title="View Form" arrow>
                        <motion.button
                          whileHover={{ scale: 1.2, color: "#22C55E" }}
                          whileTap={{ scale: 0.9 }}
                          type="button"
                          onClick={() => navigate(`/admin/event-registrations?id=${item.id}`)}
                          className="text-blue-500 focus:outline-none mx-4 hover:text-green-500">
                          <FontAwesomeIcon icon={faFile} className="text-xl" />
                        </motion.button>
                      </Tooltip>
                      <Tooltip title="View Form" arrow>
                        <motion.button
                          whileHover={{ scale: 1.2, color: "#22C55E" }}
                          whileTap={{ scale: 0.9 }}
                          type="button"
                          onClick={() => navigate(`/admin/eventRegistrationsList`,{state:{id:item.id}})}
                          className="text-blue-500 focus:outline-none mx-4 hover:text-green-500">
                          <FontAwesomeIcon icon={faFile} className="text-xl" />
                        </motion.button>
                      </Tooltip>

                    </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={8}
                      className="text-1xl text-center align-middle bg-red-300 text-red-600 font-semibold p-4"
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {/* {
              currentItems.length ?
                <div className="flex justify-center mt-4 space-x-2 bg-gray-100 p-2 rounded-lg">
                  <button
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    className={`py-2 px-4 mx-1 rounded-lg border ${currentPage === 1
                      ? 'bg-gray-300 text-black-900 cursor-not-allowed'
                      : 'bg-gray-300 text-black-900 border-gray-400 hover:bg-gray-400'
                      }`}>
                    <span>
                      <svg
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.5 9.8125H4.15625L9.46875 4.40625C9.75 4.125 9.75 3.6875 9.46875 3.40625C9.1875 3.125 8.75 3.125 8.46875 3.40625L2 9.96875C1.71875 10.25 1.71875 10.6875 2 10.9688L8.46875 17.5312C8.59375 17.6562 8.78125 17.75 8.96875 17.75C9.15625 17.75 9.3125 17.6875 9.46875 17.5625C9.75 17.2812 9.75 16.8438 9.46875 16.5625L4.1875 11.2188H17.5C17.875 11.2188 18.1875 10.9062 18.1875 10.5312C18.1875 10.125 17.875 9.8125 17.5 9.8125Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                  </button>
                  {(() => {
                    const pagesToShow = 3;
                    let startPage = Math.max(currentPage - 1, 1);
                    let endPage = Math.min(startPage + pagesToShow - 1, totalPages);

                    if (endPage - startPage + 1 < pagesToShow) {
                      startPage = Math.max(endPage - pagesToShow + 1, 1);
                    }
                    const pages = [];
                    for (let i = startPage; i <= endPage; i++) {
                      pages.push(
                        <button
                          key={i}
                          className={`py-2 px-4 mx-1 rounded-lg border ${currentPage === i
                            ? 'bg-blue-500 text-black'
                            : 'bg-gray-300 text-gray-700 border-gray-400 hover:bg-gray-400'
                            }`}
                          onClick={() => setCurrentPage(i)}
                        >
                          {i}
                        </button>
                      );
                    }
                    return pages;
                  })()}

                  <button
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    className={`py-2 px-4 mx-1 rounded-lg border ${currentPage === totalPages
                    ? 'bg-gray-300 text-black-900 cursor-not-allowed'
                    : 'bg-gray-300 text-black-900 border-gray-400 hover:bg-gray-400'
                    }`}>
                    <span>
                      <svg
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18 10L11.5312 3.4375C11.25 3.15625 10.8125 3.15625 10.5312 3.4375C10.25 3.71875 10.25 4.15625 10.5312 4.4375L15.7812 9.78125H2.5C2.125 9.78125 1.8125 10.0937 1.8125 10.4688C1.8125 10.8438 2.125 11.1875 2.5 11.1875H15.8437L10.5312 16.5938C10.25 16.875 10.25 17.3125 10.5312 17.5938C10.6562 17.7188 10.8437 17.7812 11.0312 17.7812C11.2187 17.7812 11.4062 17.7188 11.5312 17.5625L18 11C18.2812 10.7187 18.2812 10.2812 18 10Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                  </button>
                </div> : ''
            } */}

            {currentItems.length > 0 && (
              <div className="flex justify-center mt-4 bg-gray-100 p-4 rounded-lg">
                <TablePagination
                  component="p"
                  count={totalItems} // total number of items, not pages
                  page={currentPage - 1} // MUI pages are 0-indexed
                  onPageChange={(event, newPage) => setCurrentPage(newPage + 1)}
                  rowsPerPage={itemsPerPage}
                  onRowsPerPageChange={(event) => {
                    setItemsPerPage(parseInt(event.target.value, 10));
                    setCurrentPage(1);
                  }}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  labelRowsPerPage="Items per page"
                  sx={{
                    "& .MuiTablePagination-toolbar": {
                      fontWeight: 500,
                      fontSize: "0.75rem",
                    },
                    "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                    {
                      fontWeight: 500,
                      fontSize: "0.75rem",
                    },
                    "& .MuiTablePagination-select": {
                      fontWeight: 500,
                      fontSize: "0.75rem",
                    },
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
